import surveys from './survey';
import surveySources from './source';
import surveyResponses from './response';
import surveyResults from './result';
import surveyPages from './page';
import surveyTemplatePages from './template-page';
import surveyTemplateQuestions from './template-question';
import surveyQuestions from './question';
import surveyTemplates from './template';
import surveyThemes from './theme';
import surveyThemesGallery from './theme-gallery';
export default {
    surveys,
    surveyPages,
    surveyQuestions,
    surveyTemplates,
    surveyTemplatePages,
    surveyTemplateQuestions,
    surveySources,
    surveyResponses,
    surveyResults,
    surveyThemes,
    surveyThemesGallery
}
